module.exports = __webpack_public_path__ + "static/img/technology_bg.e066062.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology_bg.png
// module id = w9Gb
// module chunks = 1